import { API_BASE_URL } from "./config";

export const getTeam = () => {
  return fetch(`${API_BASE_URL}/api/v1/team/teams`, {
    method: "GET",
  });
};

export const getServices = () => {
  return fetch(`${API_BASE_URL}/api/v1/service/services`, {
    method: "GET",
  });
};
